// @boty/i18n - Middleware helper for Next.js apps
import createMiddleware from 'next-intl/middleware';
import { middlewareConfig } from './config';

// Pre-configured middleware for apps to use
// Usage in app middleware.ts:
// export { createI18nMiddleware as default } from '@boty/i18n';
export const createI18nMiddleware = () =>
  createMiddleware(middlewareConfig);

// Middleware matcher configuration for Next.js config
// This ensures the middleware runs on all paths except static files
export const i18nMiddlewareMatcher = [
  // Match all pathnames except for:
  // - api routes
  // - static files
  // - internal next routes
  '/((?!api|_next/static|_next/image|favicon.ico|.*\\..*).*)',
];

// Alternative matcher that explicitly lists locale paths
export const i18nExplicitMatcher = ['/', '/(en|he)/:path*'];
